var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUpButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.974,
    height: 15,
    viewBox: "0 0 14.974 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2500",
    "data-name": "Group 2500",
    transform: "translate(-3707.909 -8796.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(3711.431 8800.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M9.174,2.783H8.522V2.522a.522.522,0,0,0-1.043,0v.261H6.435V2.522a.522.522,0,0,0-1.043,0v.261H4.348V2.522a.522.522,0,0,0-1.043,0v.261H2.652A.652.652,0,0,0,2,3.435V8.652a.652.652,0,0,0,.652.652H6.3a.13.13,0,1,0,0-.261H2.652a.392.392,0,0,1-.391-.391V4.609h7.3V6.826a.13.13,0,1,0,.261,0V3.435a.652.652,0,0,0-.652-.652ZM7.739,2.522a.261.261,0,0,1,.522,0V3.3a.261.261,0,0,1-.522,0Zm-2.087,0a.261.261,0,0,1,.522,0V3.3a.261.261,0,0,1-.522,0Zm-2.087,0a.261.261,0,0,1,.522,0V3.3a.261.261,0,0,1-.522,0Zm6,1.826h-7.3V3.435a.392.392,0,0,1,.391-.391H3.3V3.3a.522.522,0,0,0,1.043,0V3.043H5.391V3.3a.522.522,0,0,0,1.043,0V3.043H7.478V3.3a.522.522,0,0,0,1.043,0V3.043h.652a.392.392,0,0,1,.391.391Z",
    transform: "translate(-2 -2)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6195",
    "data-name": "Path 6195",
    d: "M23.043,27.261A.261.261,0,0,0,22.783,27h-.522a.261.261,0,0,0-.261.261v.391a.261.261,0,0,0,.261.261h.522a.261.261,0,0,0,.261-.261Zm-.783.391v-.391h.522v.391Z",
    transform: "translate(-19.391 -23.739)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6196",
    "data-name": "Path 6196",
    d: "M11.043,27.261A.261.261,0,0,0,10.783,27h-.522a.261.261,0,0,0-.261.261v.391a.261.261,0,0,0,.261.261h.522a.261.261,0,0,0,.261-.261Zm-.783.391v-.391h.522v.391Z",
    transform: "translate(-8.957 -23.739)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6197",
    "data-name": "Path 6197",
    d: "M46.783,27.913a.261.261,0,0,0,.261-.261v-.391A.261.261,0,0,0,46.783,27h-.522a.261.261,0,0,0-.261.261v.391a.261.261,0,0,0,.261.261Zm-.522-.652h.522v.391h-.522Z",
    transform: "translate(-40.261 -23.739)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6198",
    "data-name": "Path 6198",
    d: "M23.043,36.261A.261.261,0,0,0,22.783,36h-.522a.261.261,0,0,0-.261.261v.391a.261.261,0,0,0,.261.261h.522a.261.261,0,0,0,.261-.261Zm-.783.391v-.391h.522v.391Z",
    transform: "translate(-19.391 -31.565)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6199",
    "data-name": "Path 6199",
    d: "M11.043,36.261A.261.261,0,0,0,10.783,36h-.522a.261.261,0,0,0-.261.261v.391a.261.261,0,0,0,.261.261h.522a.261.261,0,0,0,.261-.261Zm-.783.391v-.391h.522v.391Z",
    transform: "translate(-8.957 -31.565)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6200",
    "data-name": "Path 6200",
    d: "M22.783,45h-.522a.261.261,0,0,0-.261.261v.391a.261.261,0,0,0,.261.261h.522a.261.261,0,0,0,.261-.261v-.391A.261.261,0,0,0,22.783,45Zm-.522.652v-.391h.522v.391Z",
    transform: "translate(-19.391 -39.391)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6201",
    "data-name": "Path 6201",
    d: "M34.261,27.913h.522a.261.261,0,0,0,.261-.261v-.391A.261.261,0,0,0,34.783,27h-.522a.261.261,0,0,0-.261.261v.391A.261.261,0,0,0,34.261,27.913Zm0-.652h.522v.391h-.522Z",
    transform: "translate(-29.826 -23.739)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6202",
    "data-name": "Path 6202",
    d: "M34,36.652a.261.261,0,0,0,.261.261.13.13,0,0,0,0-.261v-.391h.522a.13.13,0,0,0,0-.261h-.522a.261.261,0,0,0-.261.261Z",
    transform: "translate(-29.826 -31.565)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6203",
    "data-name": "Path 6203",
    d: "M10.783,45h-.522a.261.261,0,0,0-.261.261v.391a.261.261,0,0,0,.261.261h.522a.261.261,0,0,0,.261-.261v-.391A.261.261,0,0,0,10.783,45Zm-.522.652v-.391h.522v.391Z",
    transform: "translate(-8.957 -39.391)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6204",
    "data-name": "Path 6204",
    d: "M37.7,36a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,37.7,36Zm0,3.13A1.435,1.435,0,1,1,39.13,37.7,1.435,1.435,0,0,1,37.7,39.13Z",
    transform: "translate(-31.565 -31.565)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6205",
    "data-name": "Path 6205",
    d: "M43.456,44.553l-1.015,1.015-.461-.461a.13.13,0,1,0-.184.184l.553.553a.13.13,0,0,0,.184,0l1.107-1.107a.13.13,0,1,0-.184-.184Z",
    transform: "translate(-36.572 -38.97)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_16",
    "data-name": "Subtraction 16",
    d: "M7.5,15a7.187,7.187,0,0,1-1.043-.075,6.68,6.68,0,0,1-1.943-.6,7.063,7.063,0,0,1-.894-.518,9.764,9.764,0,0,1-3-3.486v1.837a.313.313,0,0,1-.625,0V9.687a.313.313,0,0,1,.313-.312h2.5a.312.312,0,1,1,0,.625H1.161c1.084,2,3.064,4.375,6.344,4.375a6.862,6.862,0,0,0,6.841-6.143.382.382,0,0,1,.268-.112.609.609,0,0,1,.357.143,7.467,7.467,0,0,1-1.508,3.792,7.563,7.563,0,0,1-1.992,1.809A7.468,7.468,0,0,1,7.5,15ZM.313,7.812A.313.313,0,0,1,0,7.5,7.483,7.483,0,0,1,.294,5.417a.724.724,0,0,1,.2-.03.457.457,0,0,1,.213.048.389.389,0,0,1,.176.195A6.861,6.861,0,0,0,.625,7.5.313.313,0,0,1,.313,7.812Zm14.352-.859h0a.508.508,0,0,1-.218-.056.594.594,0,0,1-.093-.056h0a6.907,6.907,0,0,0-.377-1.678c.008-.017.017-.035.026-.055a.405.405,0,0,1,.173-.2.429.429,0,0,1,.209-.05.666.666,0,0,1,.154.019c.027.073.054.147.079.221a7.452,7.452,0,0,1,.358,1.671A.365.365,0,0,1,14.665,6.954ZM1.241,4.351h0a.431.431,0,0,1-.228-.057.377.377,0,0,1-.166-.252A7.537,7.537,0,0,1,1.962,2.448a.447.447,0,0,1,.472.4v0A6.952,6.952,0,0,0,1.4,4.334l0,0A.618.618,0,0,1,1.241,4.351Zm12.31-.393h0a.642.642,0,0,1-.159-.021A6.79,6.79,0,0,0,12.234,2.5a.368.368,0,0,1,.1-.177.46.46,0,0,1,.155-.094.712.712,0,0,1,.237-.043h.006l.045-.015a7.591,7.591,0,0,1,.742.852c.148.2.288.406.415.618v.006A.368.368,0,0,1,13.551,3.958Zm-10.12-2h0a.532.532,0,0,1-.353-.149.382.382,0,0,1-.083-.3c.183-.138.374-.268.567-.388A7.5,7.5,0,0,1,4.933.454a.5.5,0,0,1,.2.172.439.439,0,0,1,.02.408h0a6.853,6.853,0,0,0-1.724.924Zm7.834-.22a6.952,6.952,0,0,0-1.7-.8A.422.422,0,0,1,9.739.352L9.748.346l0,0a7.476,7.476,0,0,1,1.851.876c0,.018,0,.036.007.055a.373.373,0,0,1-.1.348.514.514,0,0,1-.242.116h0ZM6.359.719h0A.5.5,0,0,1,6.2.548.376.376,0,0,1,6.155.361a.5.5,0,0,1,.081-.25l0,0A7.565,7.565,0,0,1,8.413.055a.507.507,0,0,1,.109.24.432.432,0,0,1-.16.384,6.987,6.987,0,0,0-2,.041Z",
    transform: "translate(3707.909 8796.974)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpButton);
export default __webpack_public_path__ + "static/media/FollowUpButton.2f9d32ba76c814df7cc025e9f59fd44c.svg";
export { ForwardRef as ReactComponent };